import styled from 'styled-components';
import { Icon } from '../../../elements/Icon';
export const ArrowLeft = styled(Icon.ChevronLeft) `
  --icon-size: 14px;
  --icon-color: ${({ theme }) => theme.secondary.blendToBackground(600)};

  padding: 4px;
  background-color: ${({ theme }) => theme.background};
  border-radius: 50%;
  box-shadow: inset 0 0 0 1px ${({ theme }) => theme.secondary.blendToBackground(200)};
  position: absolute;
  left: var(--sticky-left-offset);
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  opacity: var(--sticky-left-show);
  transition: opacity 0.3s;
  z-index: 4;
  margin-top: 19px;
  pointer-events: none;
`;
//# sourceMappingURL=ArrowLeft.js.map